import { Interval } from '../models/Interval';
import { toDateOnly } from './dates';
import { intervalTypeLabel } from '../pages/intervals/intervalModal/utils/intervalTypeHelper';

type LabelledInterval = {
  intervalType: string;
  debitType?: string | null;
  description?: string | null;
  startDate?: string | null;
};

// An order can have several intervals of the same type, so the description and start date are
// what tell them apart.
export const formatIntervalLabel = (interval: LabelledInterval): string => {
  const type = intervalTypeLabel({
    intervalType: interval.intervalType as Interval['intervalType'],
    debitType: interval.debitType,
  });
  const start = interval.startDate ? `från ${toDateOnly(interval.startDate)}` : '';
  const details = [type, start].filter(Boolean).join(', ');
  const description = interval.description?.trim();

  if (!description) return details;
  return details ? `${description} (${details})` : description;
};
